import { API_BASE } from '../../../api';

export const ENDPOINTS = {
    correoPlantilla: `${API_BASE}/CorreoPlantilla`,
    correoPlantillaById: (id) => `${API_BASE}/CorreoPlantilla/${id}`,
    firmas: `${API_BASE}/Firma`,
    firmasById: (id) => `${API_BASE}/Firma/${id}`,

    certificaciones: `${API_BASE}/Certificacion`,
    certificacionesById: (id) => `${API_BASE}/Certificacion/${id}`,
    certificacionesByCursoHistorico: (idCurso) => `${API_BASE}/Certificacion/curso/${idCurso}/historico`,

    certificadoCarrera: `${API_BASE}/CertificadoCarrera`,
    certificadoCarreraById: (id) => `${API_BASE}/CertificadoCarrera/${id}`,
    certificadoCarreraByCarrera: (idCarrera) => `${API_BASE}/CertificadoCarrera/Carrera/${idCarrera}`,
    certificadoCarreraGenerateForStudent: `${API_BASE}/CertificadoCarrera/GenerateForStudent`,

    instructor: `${API_BASE}/Instructor`,
    instructorById: (id) => `${API_BASE}/Instructor/${id}`,
    instructorByUsuario: (idUsuario) => `${API_BASE}/Instructor/Usuario/${idUsuario}`,

    leccionEstudiante: `${API_BASE}/LeccionEstudiante`,
    leccionEstudianteById: (id) => `${API_BASE}/LeccionEstudiante/${id}`,

    catEstados: `${API_BASE}/Estado`,
    catEstadosById: (id) => `${API_BASE}/Estado/${id}`,

    estudiante: `${API_BASE}/Estudiante`,
    estudianteById: (id) => `${API_BASE}/Estudiante/${id}`,
    estudianteByUsuario: (idUsuario) => `${API_BASE}/Estudiante/Usuario/${idUsuario}`,
    usuarioRol: `${API_BASE}/UsuarioRol`,
    usuarioRolByUsuario: (idUsuario) => `${API_BASE}/UsuarioRol/Usuario/${idUsuario}`,

    estudiantesCurso: `${API_BASE}/EstudianteCurso`,
    estudiantesCursoById: (id) => `${API_BASE}/EstudianteCurso/${id}`,
    estudiantesCursoByEstudiante: (idEstudiante) => `${API_BASE}/EstudianteCurso/Estudiante/${idEstudiante}`,
    estudiantesCursoStored: (studentId) => `${API_BASE}/EstudianteCurso/stored/${studentId}`,
    estudiantesCursoReactivate: (id) => `${API_BASE}/EstudianteCurso/reactivate/${id}`,
    estudianteCursoProgresoDetalle: (idInstructor, idCurso) => `${API_BASE}/EstudianteCurso/progreso-detalle?idInstructor=${idInstructor}${idCurso ? `&idCurso=${idCurso}` : ''}`,
    misCursos: (idUsuario) => `${API_BASE}/EstudianteCurso/mis-cursos/${idUsuario}`,
    estudianteCursoAsignarPorArea: `${API_BASE}/EstudianteCurso/AsignarPorArea`,
    estudianteCursoAsignarPorPuesto: `${API_BASE}/EstudianteCurso/AsignarPorPuesto`,
    estudianteCursoAsignarPorTurno: `${API_BASE}/EstudianteCurso/AsignarPorTurno`,
    estudianteCursoReiniciarProgreso: (idCurso, idEstudiante) => `${API_BASE}/EstudianteCurso/reiniciar-progreso/${idCurso}/${idEstudiante}`,
    estudianteCursoSeguimiento: (idUsuario) => `${API_BASE}/EstudianteCurso/seguimiento/${idUsuario}`,
    estudianteCursoConteos: `${API_BASE}/EstudianteCurso/conteos`,

    puestoCurso: `${API_BASE}/PuestoCurso`,
    puestoCursoByPuesto: (idPuesto, idEmpresa) => `${API_BASE}/PuestoCurso/${idPuesto}/${idEmpresa}`,
    puestoCursoAsignar: `${API_BASE}/PuestoCurso/asignar`,
    puestoCursoDesasignar: `${API_BASE}/PuestoCurso/desasignar`,
    puestoCursoConteos: `${API_BASE}/PuestoCurso/conteos`,

    cursos: `${API_BASE}/Curso`,
    cursosAll: `${API_BASE}/Curso/all`,
    cursosAdmin: `${API_BASE}/Curso/admin`,
    cursosAdminHistorico: `${API_BASE}/Curso/admin-historico`,
    cursosById: (id) => `${API_BASE}/Curso/${id}`,
    cursosDisponiblesByEstudiante: (idEstudiante) => `${API_BASE}/Curso/disponibles/${idEstudiante}`,
    cursosDisponiblesByUsuario: (idUsuario) => `${API_BASE}/Curso/usuario-disponibles/${idUsuario}`,
    cursosByInstructor: (idInstructor) => `${API_BASE}/Curso/instructor/${idInstructor}`,
    cursosByUsuarioCreados: (idUsuario) => `${API_BASE}/Curso/usuario-creados/${idUsuario}`,
    cursosMarketplace: (idUsuario, params = {}) => {
        const cleanParams = Object.fromEntries(
            Object.entries({ idUsuario, ...params }).filter(([_, v]) =>
                v !== null &&
                v !== undefined &&
                v !== '' &&
                v !== 'undefined' &&
                v !== 'null'
            )
        );
        const query = new URLSearchParams(cleanParams).toString();
        return `${API_BASE}/Curso/marketplace?${query}`;
    },
    cursosPendientesRevision: (idUsuarioAdmin) => `${API_BASE}/Curso/pendientes-revision/${idUsuarioAdmin}`,
    cursosActualizarMonedas: `${API_BASE}/Curso/actualizar-monedas`,
    cursosAsociacionesCarrera: (id) => `${API_BASE}/Curso/AsociacionesCarrera/${id}`,

    estadisticasCursoByIdCurso: (idCurso) => `${API_BASE}/Estadisticas/curso/${idCurso}`,
    estadisticasEstudianteDetalle: (idEstudiante) => `${API_BASE}/Estadisticas/estudiante/${idEstudiante}`,
    estadisticasExportarExcel: `${API_BASE}/Estadisticas/exportar-excel`,

    catNivel: `${API_BASE}/Nivel`,
    catNivelById: (id) => `${API_BASE}/Nivel/${id}`,

    catTipoHabilidad: `${API_BASE}/TipoHabilidad`,
    catTipoHabilidadById: (id) => `${API_BASE}/TipoHabilidad/${id}`,

    peticionesCertificado: `${API_BASE}/PeticionCertificado`,
    peticionesCertificadoById: (id) => `${API_BASE}/PeticionCertificado/${id}`,

    examenesIntentos: `${API_BASE}/ExamenIntento`,
    examenesIntentosById: (id) => `${API_BASE}/ExamenIntento/${id}`,

    examenesRespuestas: `${API_BASE}/ExamenRespuesta`,
    examenesRespuestasById: (id) => `${API_BASE}/ExamenRespuesta/${id}`,

    respuestaExamenTextoLibre: `${API_BASE}/RespuestaExamenTextoLibre`,
    respuestaExamenTextoLibreById: (id) => `${API_BASE}/RespuestaExamenTextoLibre/${id}`,

    respuestaExamenVerdaderoFalso: `${API_BASE}/RespuestaExamenVerdaderoFalso`,
    respuestaExamenVerdaderoFalsoById: (id) => `${API_BASE}/RespuestaExamenVerdaderoFalso/${id}`,

    respuestaExamenOpcionMultipleDet: `${API_BASE}/RespuestaExamenOpcionMultipleDet`,
    respuestaExamenOpcionMultipleDetById: (id) => `${API_BASE}/RespuestaExamenOpcionMultipleDet/${id}`,

    examen: `${API_BASE}/Examen`,
    examenById: (id) => `${API_BASE}/Examen/${id}`,
    examenByCurso: (idCurso) => `${API_BASE}/Examen/Curso/${idCurso}`,

    examenPreguntas: `${API_BASE}/ExamenPregunta`,
    examenPreguntasById: (id) => `${API_BASE}/ExamenPregunta/${id}`,
    examenPreguntasByExamen: (idExamen) => `${API_BASE}/ExamenPregunta/Examen/${idExamen}`,

    examenPreguntaTextoLibre: `${API_BASE}/ExamenPreguntaTextoLibre`,
    examenPreguntaTextoLibreById: (id) => `${API_BASE}/ExamenPreguntaTextoLibre/${id}`,
    examenPreguntaTextoLibreByExamen: (idExamen) => `${API_BASE}/ExamenPreguntaTextoLibre/Examen/${idExamen}`,

    examenPreguntaOpcionMultiple: `${API_BASE}/ExamenPreguntaOpcionMultiple`,
    examenPreguntaOpcionMultipleById: (id) => `${API_BASE}/ExamenPreguntaOpcionMultiple/${id}`,
    examenPreguntaOpcionMultipleByPregunta: (idPregunta) => `${API_BASE}/ExamenPreguntaOpcionMultiple/ExamenPregunta/${idPregunta}`,

    examenPreguntaOpcionMultipleOpciones: `${API_BASE}/ExamenPreguntaOpcionMultipleOpcion`,
    examenPreguntaOpcionMultipleOpcionesById: (id) => `${API_BASE}/ExamenPreguntaOpcionMultipleOpcion/${id}`,
    examenPreguntaOpcionMultipleOpcionesByRespuesta: (idRespuesta) => `${API_BASE}/ExamenPreguntaOpcionMultipleOpcion/examen-opcion-multiple/${idRespuesta}`,

    examenPreguntaVerdaderoFalso: `${API_BASE}/ExamenPreguntaVerdaderoFalso`,
    examenPreguntaVerdaderoFalsoById: (id) => `${API_BASE}/ExamenPreguntaVerdaderoFalso/${id}`,
    examenPreguntaVerdaderoFalsoByExamen: (idExamen) => `${API_BASE}/ExamenPreguntaVerdaderoFalso/Examen/${idExamen}`,

    cuestionario: `${API_BASE}/Cuestionario`,
    cuestionarioById: (id) => `${API_BASE}/Cuestionario/${id}`,
    cuestionarioByCurso: (idCurso) => `${API_BASE}/Cuestionario/curso/${idCurso}`,

    cuestionariosPreguntas: `${API_BASE}/CuestionarioPregunta`,
    cuestionariosPreguntasById: (id) => `${API_BASE}/CuestionarioPregunta/${id}`,
    cuestionariosPreguntasByCuestionario: (idCuestionario) => `${API_BASE}/CuestionarioPregunta/cuestionario/${idCuestionario}`,

    cuestionarioRespuestaTextoLibre: `${API_BASE}/CuestionarioRespuestaTextoLibre`,
    cuestionarioRespuestaTextoLibreById: (id) => `${API_BASE}/CuestionarioRespuestaTextoLibre/${id}`,
    cuestionarioRespuestaTextoLibreByCuestionario: (idCuestionario) => `${API_BASE}/CuestionarioRespuestaTextoLibre/cuestionario/${idCuestionario}`,

    cuestionarioRespuestaOpcionMultiple: `${API_BASE}/CuestionarioRespuestaOpcionMultiple`,
    cuestionarioRespuestaOpcionMultipleById: (id) => `${API_BASE}/CuestionarioRespuestaOpcionMultiple/${id}`,
    cuestionarioRespuestaOpcionMultipleByPregunta: (idPregunta) => `${API_BASE}/CuestionarioRespuestaOpcionMultiple/pregunta/${idPregunta}`,

    cuestionarioRespuestaOpcionMultipleOpciones: `${API_BASE}/CuestionarioRespuestaOpcionMultipleOpcion`,
    cuestionarioRespuestaOpcionMultipleOpcionesById: (id) => `${API_BASE}/CuestionarioRespuestaOpcionMultipleOpcion/${id}`,
    cuestionarioRespuestaOpcionMultipleOpcionesByRespuesta: (idRespuesta) => `${API_BASE}/CuestionarioRespuestaOpcionMultipleOpcion/respuesta-opcion-multiple/${idRespuesta}`,

    cuestionarioRespuestaVerdaderoFalso: `${API_BASE}/CuestionarioRespuestaVerdaderoFalso`,
    cuestionarioRespuestaVerdaderoFalsoById: (id) => `${API_BASE}/CuestionarioRespuestaVerdaderoFalso/${id}`,
    cuestionarioRespuestaVerdaderoFalsoByCuestionario: (idCuestionario) => `${API_BASE}/CuestionarioRespuestaVerdaderoFalso/cuestionario/${idCuestionario}`,

    cuestionariosIntentos: `${API_BASE}/CuestionarioIntento`,
    cuestionariosIntentosById: (id) => `${API_BASE}/CuestionarioIntento/${id}`,

    cuestionariosRespuestas: `${API_BASE}/CuestionarioRespuesta`,
    cuestionariosRespuestasById: (id) => `${API_BASE}/CuestionarioRespuesta/${id}`,

    respuestaCuestionarioTextoLibre: `${API_BASE}/RespuestaCuestionarioTextoLibre`,
    respuestaCuestionarioTextoLibreById: (id) => `${API_BASE}/RespuestaCuestionarioTextoLibre/${id}`,

    respuestaCuestionarioOpcionMultipleDet: `${API_BASE}/RespuestaCuestionarioOpcionMultipleDet`,
    respuestaCuestionarioOpcionMultipleDetById: (id) => `${API_BASE}/RespuestaCuestionarioOpcionMultipleDet/${id}`,

    respuestaCuestionarioVerdaderoFalso: `${API_BASE}/RespuestaCuestionarioVerdaderoFalso`,
    respuestaCuestionarioVerdaderoFalsoById: (id) => `${API_BASE}/RespuestaCuestionarioVerdaderoFalso/${id}`,

    propiedadesContenido: `${API_BASE}/PropiedadContenido`,
    propiedadesContenidoById: (id) => `${API_BASE}/PropiedadContenido/${id}`,

    catPropiedades: `${API_BASE}/Propiedad`,
    catPropiedadesById: (id) => `${API_BASE}/Propiedad/${id}`,

    contenidoTipo: `${API_BASE}/ContenidoTipo`,
    contenidoTipoById: (id) => `${API_BASE}/ContenidoTipo/${id}`,

    leccionesContenido: `${API_BASE}/LeccionContenido`,
    leccionesContenidoById: (id) => `${API_BASE}/LeccionContenido/${id}`,
    leccionesContenidoByLeccion: (idLeccion) => `${API_BASE}/LeccionContenido/Leccion/${idLeccion}`,
    lecciones: `${API_BASE}/Leccion`,
    leccionesById: (id) => `${API_BASE}/Leccion/${id}`,
    leccionesByCurso: (idCurso) => `${API_BASE}/Leccion/curso/${idCurso}`,

    modulo: `${API_BASE}/Modulo`,
    moduloById: (id) => `${API_BASE}/Modulo/${id}`,
    moduloByCurso: (idCurso) => `${API_BASE}/Modulo/curso/${idCurso}`,

    moduloContenido: `${API_BASE}/ModuloContenido`,
    moduloContenidoById: (id) => `${API_BASE}/ModuloContenido/${id}`,
    moduloContenidoByCurso: (idCurso) => `${API_BASE}/ModuloContenido/curso/${idCurso}`,

    cursoOpinion: `${API_BASE}/CursoOpinion`,
    cursoOpinionById: (id) => `${API_BASE}/CursoOpinion/${id}`,

    cursoRating: `${API_BASE}/CursoCalificacion`,
    cursoRatingById: (id) => `${API_BASE}/CursoCalificacion/${id}`,

    estudianteCertificaciones: `${API_BASE}/EstudianteCertificacion`,
    estudianteCertificacionesDetalles: (idEstudiante) => `${API_BASE}/EstudianteCertificacion/detalles/estudiante/${idEstudiante}`,
    estudianteCertificacionesById: (id) => `${API_BASE}/EstudianteCertificacion/${id}`,

    estudiantesPremios: `${API_BASE}/EstudiantePremio`,
    estudiantesPremiosDetalles: `${API_BASE}/EstudiantePremio/detalles`,
    estudiantesPremiosById: (id) => `${API_BASE}/EstudiantePremio/${id}`,
    estudiantesPremiosByEstudiante: (idEstudiante) => `${API_BASE}/EstudiantePremio/Estudiante/${idEstudiante}`,
    tiendaData: (idUsuario) => `${API_BASE}/EstudiantePremio/tienda/usuario/${idUsuario}`,
    tiendaComprar: (idEstudiante, idPremio) => `${API_BASE}/EstudiantePremio/comprar?idEstudiante=${idEstudiante}&idPremio=${idPremio}`,

    catPremios: `${API_BASE}/Premio`,
    catPremiosById: (id) => `${API_BASE}/Premio/${id}`,

    catTipoPregunta: `${API_BASE}/TipoPregunta`,
    catTipoPreguntaById: (id) => `${API_BASE}/TipoPregunta/${id}`,

    observacionCurso: `${API_BASE}/ObservacionCurso`,
    observacionCursoById: (id) => `${API_BASE}/ObservacionCurso/${id}`,

    observacionCarrera: `${API_BASE}/ObservacionCarrera`,
    observacionCarreraById: (id) => `${API_BASE}/ObservacionCarrera/${id}`,

    referencias: `${API_BASE}/Referencias`,
    referenciasById: (id) => `${API_BASE}/Referencias/${id}`,

    // General (copias para independencia de módulo)
    empleados: `${API_BASE}/Empleados`,
    empleadosById: (id) => `${API_BASE}/Empleados/${id}`,

    personas: `${API_BASE}/Personas`,
    personasById: (id) => `${API_BASE}/Personas/${id}`,

    usuarios: `${API_BASE}/Usuarios`,
    usuariosById: (id) => `${API_BASE}/Usuarios/${id}`,

    certificadosGenerate: `${API_BASE}/Certificados/generate`,

    // Áreas de Negocio Cursos
    areaNegocioCurso: `${API_BASE}/AreaNegocioCurso`,
    areaNegocioCursoByArea: (idArea, idEmpresa) => `${API_BASE}/AreaNegocioCurso/${idArea}/${idEmpresa}`,
    areaNegocioCursoAsignar: `${API_BASE}/AreaNegocioCurso/asignar`,
    areaNegocioCursoDesasignar: `${API_BASE}/AreaNegocioCurso/desasignar`,
    areaNegocioCursoConteos: `${API_BASE}/AreaNegocioCurso/conteos`,

    carreras: `${API_BASE}/Carrera`,
    carrerasAdmin: `${API_BASE}/Carrera/admin`,
    carrerasHistorico: `${API_BASE}/Carrera/historico`,
    carrerasById: (id) => `${API_BASE}/Carrera/${id}`,
    carrerasByInstructor: (idInstructor) => `${API_BASE}/Carrera/Instructor/${idInstructor}`,
    carrerasMarketplace: (idUsuario) => `${API_BASE}/Carrera/marketplace?idUsuario=${idUsuario}`,

    semestres: `${API_BASE}/Semestre`,
    semestresById: (id) => `${API_BASE}/Semestre/${id}`,

    peticionRevisionCarrera: `${API_BASE}/PeticionRevisionCarrera`,
    peticionRevisionCarreraByCarrera: (idCarrera) => `${API_BASE}/PeticionRevisionCarrera/Carrera/${idCarrera}`,

    semestreCurso: `${API_BASE}/SemestreCurso`,
    semestreCursoById: (id) => `${API_BASE}/SemestreCurso/${id}`,
    semestresHistoricoEstudiante: (idCarrera, idEstudiante) => `${API_BASE}/SemestreCurso/historico-estudiante/${idCarrera}/${idEstudiante}`,

    carreraEstudiante: `${API_BASE}/CarreraEstudiante`,
    carreraEstudianteById: (id) => `${API_BASE}/CarreraEstudiante/${id}`,
    carreraEstudianteSyncProgreso: `${API_BASE}/CarreraEstudiante/SyncProgreso`,
    carreraEstudianteSyncTodas: (idEstudiante) => `${API_BASE}/CarreraEstudiante/SyncTodas/${idEstudiante}`,
    carreraEstudianteStored: (idEstudiante) => `${API_BASE}/CarreraEstudiante/stored/${idEstudiante}`,
    misCarreras: (idUsuario) => `${API_BASE}/CarreraEstudiante/mis-carreras/${idUsuario}`,
    misCarrerasHistorico: (idUsuario) => `${API_BASE}/CarreraEstudiante/mis-carreras-historico/${idUsuario}`,

    estudiantesCursoByCurso: (idCurso) => `${API_BASE}/EstudianteCurso/Curso/${idCurso}`,
    estudianteCertificacionesCarreraByEstudiante: (idEstudiante) => `${API_BASE}/EstudianteCertificacionCarrera/Estudiante/${idEstudiante}`,

    // Asignación Masiva
    asignacionMasivaUnidadOrganizacional: `${API_BASE}/AsignacionMasivaUnidadOrganizacional`,
    asignacionMasivaUnidadOrganizacionalById: (id) => `${API_BASE}/AsignacionMasivaUnidadOrganizacional/${id}`,

    asignacionMasivaEmpresa: `${API_BASE}/AsignacionMasivaEmpresa`,
    asignacionMasivaEmpresaById: (id) => `${API_BASE}/AsignacionMasivaEmpresa/${id}`,

    asignacionMasivaAreaNegocio: `${API_BASE}/AsignacionMasivaAreaNegocio`,
    asignacionMasivaAreaNegocioById: (id) => `${API_BASE}/AsignacionMasivaAreaNegocio/${id}`,

    asignacionMasivaPuesto: `${API_BASE}/AsignacionMasivaPuesto`,
    asignacionMasivaPuestoById: (id) => `${API_BASE}/AsignacionMasivaPuesto/${id}`,

    correo: `${API_BASE}/Correo`,
    peticionFechaExtendida: `${API_BASE}/PeticionFechaExtendida`,
    peticionFechaExtendidaById: (id) => `${API_BASE}/PeticionFechaExtendida/${id}`,
    peticionFechaExtendidaByEstudianteCurso: (idEstudianteCurso) => `${API_BASE}/PeticionFechaExtendida/EstudianteCurso/${idEstudianteCurso}`,

    // [NUEVO] Compartición de cursos (Multi-tenant)
    cursoEmpresaCompartida: `${API_BASE}/CursoEmpresaCompartida`,
    cursoEmpresaCompartidaPorCurso: (idCurso) => `${API_BASE}/CursoEmpresaCompartida/por-curso/${idCurso}`,
    cursoEmpresaCompartidaRecibidos: (idEmpresaDestino) => `${API_BASE}/CursoEmpresaCompartida/recibidos/${idEmpresaDestino}`,
    cursoEmpresaCompartidaDeHijas: (idEmpresaPadre) => `${API_BASE}/CursoEmpresaCompartida/compartidos-de-hijas/${idEmpresaPadre}`,
    cursoEmpresaCompartidaHermanas: (idCurso, idEmpresaPadre) => `${API_BASE}/CursoEmpresaCompartida/hermanas/${idCurso}/${idEmpresaPadre}`,
    cursoEmpresaCompartidaRecibidosEnriquecidos: (idEmpresaDestino) => `${API_BASE}/CursoEmpresaCompartida/recibidos-enriquecidos/${idEmpresaDestino}`,
    peticionRevisionCarrera: `${API_BASE}/PeticionRevisionCarrera`,
    peticionRevisionCarreraById: (id) => `${API_BASE}/PeticionRevisionCarrera/${id}`,
    peticionRevisionCarreraByCarrera: (id) => `${API_BASE}/PeticionRevisionCarrera/Carrera/${id}`,
    carrerasPendientesRevision: (idUsuarioAdmin) => `${API_BASE}/Carrera/pendientes-revision/${idUsuarioAdmin}`,
    
    // [NUEVO] Compartición de carreras (Multi-tenant)
    carreraEmpresaCompartida: `${API_BASE}/CarreraEmpresaCompartida`,
    carreraEmpresaCompartidaPorCarrera: (idCarrera) => `${API_BASE}/CarreraEmpresaCompartida/por-carrera/${idCarrera}`,
    carreraEmpresaCompartidaRecibidos: (idEmpresaDestino) => `${API_BASE}/CarreraEmpresaCompartida/recibidos/${idEmpresaDestino}`,
    carreraEmpresaCompartidaDeHijas: (idEmpresaPadre) => `${API_BASE}/CarreraEmpresaCompartida/compartidos-de-hijas/${idEmpresaPadre}`,
    carreraEmpresaCompartidaHermanas: (idCarrera, idEmpresaPadre) => `${API_BASE}/CarreraEmpresaCompartida/hermanas/${idCarrera}/${idEmpresaPadre}`,
    carreraEmpresaCompartidaRecibidosEnriquecidos: (idEmpresaDestino) => `${API_BASE}/CarreraEmpresaCompartida/recibidos-enriquecidos/${idEmpresaDestino}`,
}